import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Pagination from "@mui/material/Pagination";
import ProductGridItem from "../components/ProductGridItem";
import { getFeaturedProducts } from "../services/ProductService";

const PAGE_SIZE = 12;

function AllFeaturedProducts() {
  useEffect(() => {
    getFeaturedProducts(page, PAGE_SIZE).then(
      (res) => {
        setProducts(res.data.products);
        calculateNoOfPages(res.data.featuredProductCount);
        setIsLoaded(true);
      },
      (failure) => {
        console.error(failure); //expected output: Oopsy...
      }
    );
  }, []);

  const initProducts = [];
  const [products, setProducts] = useState(initProducts);
  const [isLoaded, setIsLoaded] = useState(false);

  const [noOfPages, setNoOfpages] = useState(1);
  const calculateNoOfPages = (tp) => {
    let tempVar = Math.ceil(tp / PAGE_SIZE);
    if (tempVar === 0) {
      tempVar = 1;
    }

    setNoOfpages(tempVar);
  };

  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    getFeaturedProducts(value, PAGE_SIZE).then(
      (res) => {
        setProducts(res.data.products);
        calculateNoOfPages(res.data.featuredProductCount);
        console.log(res);
      },
      (failure) => {
        console.error(failure); //expected output: Oopsy...
      }
    );
    setPage(value);
  };

  return (
    <section className="space-at-top">
      <div className="container">
        <Row className="pb-2">
          <Col md={12}>
            <span className="header-1">Featured Products</span>
          </Col>
        </Row>
        <Row className="mobile-grid">
          {isLoaded && (
            <Col md={12}>
              {products.length > 0 ? (
                <Row>
                  {products.map((product) => {
                    return (
                      product.published && (
                        <Col
                          lg={3}
                          md={3}
                          xs={6}
                          key={product.id}
                          className="even-spacer-y"
                        >
                          <ProductGridItem
                            imgUrl={product.pictureUrl}
                            enableWishlist={true}
                            name={product.name}
                            brand={product.manufacturerName}
                            oldPrice={product.oldPrice}
                            price={product.price}
                            id={product.id}
                          />
                        </Col>
                      )
                    );
                  })}
                  {products.length > 0 && (
                    <Col md={12}>
                      <div className="pagination-parent">
                        <Pagination
                          count={noOfPages}
                          page={page}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  )}
                </Row>
              ) : (
                <div>There is Nothing here</div>
              )}
            </Col>
          )}
        </Row>
      </div>
    </section>
  );
}

export default AllFeaturedProducts;
